import React from "react";
import { Formik, ErrorMessage } from "formik";
import {
	add,
	address,
	buildingUseQn,
	buildingUse,
	name,
	wardQuestion,
	unit,
	photo,
	areaType,
	statuskind,
	status,
	land,
	office,
	benefittedHouse,
	areaList,
	cancel,
	ward,
	selectedLanguage,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";
import FormFooterButtons from "../components/FormFooterButtons";
import { Card } from "react-bootstrap";
import { GetUUID } from "../data/helpers/RandomNumGenerator";

const initData = {
	ward: "",
	name: "",
	buildingType: "",
	address: "",
	buildingUse: "",
	memberCount: "",
	buildingCondition: "",
	land: "",
	office: "",
	status: "",
	benefittedHouse: "",
	areaType: "",
	uniqueIdentifier: GetUUID(),
};

const CommunityBuilding = (props) => (
	<div>
		<Formik
			enableReinitialize
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				// if (!values.ward) {
				//     errors.ward = 'Required';
				// }
				// if (!values.riskArea) {
				//     errors.riskArea = 'Required';
				// }
				// if (!values.address) {
				//     errors.address = 'Required';
				// }
				// if (!values.effectFromDisasters) {
				//     errors.effectFromDisasters = 'Required';
				// }
				// else
				// if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
				// 	errors.email = "Invalid email address";
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				console.log(values);
				setTimeout(() => {
					props.submit(values);
					setSubmitting(false);
				}, 400);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward}
										>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{name[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={name[selectedLanguage]}
											name="name"
											onChange={handleChange}
											value={values.name}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="name"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{address[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={address[selectedLanguage]}
											name="address"
											onChange={handleChange}
											value={values.address}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="address"
											component="div"
										/>
									</div>

									<div className="col-md-6">
										<label className="form-control-label">
											{buildingUseQn[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={buildingUse[selectedLanguage]}
											name="buildingUse"
											onChange={handleChange}
											value={values.buildingUse}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="buildingUse"
											component="div"
										/>
									</div>
								</div>

								<hr />
								<h3>{areaType[selectedLanguage]}</h3>
								<div className="form-group row">
									<div className="col-md-3">
										<label className="form-control-label">
											{land[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={land[selectedLanguage]}
											name="land"
											onChange={handleChange}
											value={values.land}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="land"
											component="div"
										/>
									</div>
									<div className="col-md-3">
										<label className="form-control-label">
											{unit[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="areaType"
											name="areaType"
											onChange={handleChange}
											value={values.areaType}
										>
											{areaList.map((type) => (
												<option value={type.value}>
													{type[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="areaType"
											component="div"
										/>
									</div>

									<div className="col-md-6">
										<label className="form-control-label">
											{office[selectedLanguage]}
										</label>
										<input
											type="number"
											className="form-control"
											placeholder={office[selectedLanguage]}
											name="office"
											onChange={handleChange}
											value={values.office}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="office"
											component="div"
										/>
									</div>
								</div>
								<hr />
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{statuskind[selectedLanguage]}{" "}
										</label>
										<select
											className="form-control"
											id="status"
											name="status"
											onChange={handleChange}
											value={values.status}
										>
											{status.map((type) => (
												<option value={type.value}>
													{type[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="status"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{benefittedHouse[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={benefittedHouse[selectedLanguage]}
											name="benefittedHouse"
											onChange={handleChange}
											value={values.benefittedHouse}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="benefittedHouse"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>

								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default CommunityBuilding;
